import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconItalic: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="italic"><path d="M9.75 3.75L19.25 3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 20.25H9.5L14.2601 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.3467 4.24927L9.64844 19.7536" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconItalic;
